<template>
  <main class="container">
    <div v-if="!isGuid(userID)">
      L'URL digitato non è corretto. Torna nel tuo profilo e utilizza l'indirizzo corretto.
    </div>
    <div v-else>
      <div v-if="denied" class="splash">
        <p>Hai negato a questo sito l'accesso alla webcam e/o al microfono.</p>
        <p>Ripristinalo nelle impostazioni del browser e ricarica la pagina.</p>
      </div>

      <div v-else-if="!supported" class="not-supported">
        <p v-if="camera && mic">Ci dispiace, ma questo device non è supportato.</p>
        <p v-if="camera && !mic">Ci dispiace, ma questo device non è supportato (oppure manca il microfono).</p>
        <p v-if="!camera && mic">Ci dispiace, ma questo device non è supportato (oppure manca la webcam).</p>
        <p v-else>Ci dispiace, ma questo device non è supportato (oppure mancano webcam e microfono).</p>
      </div>

      <div v-else>
        <div v-if="!done && !error" class="splash">
          <h1>Registra adesso il tuo motivation video!</h1>
          <p><span v-if="name !== undefined || surname !== undefined">Ciao {{ name }} {{ surname }}, p</span><span v-else>P</span>er il tuo video hai a disposizione dai 30 secondi al minuto.</p>
        </div>

        <div class="video" v-if="!postRecording">
          <div v-if="!streamStarted" class="lds-dual-ring  alone"></div>
          <span v-if="recording" class="recording"></span>
          <video id="video" playsinline autoplay muted></video>
          <p class="countdown" v-if="recordingDelayed">{{ countdown }}</p>
          <button v-if="!recording && !postRecording" @click="startRecording()" id="js-training" class="button">Registra adesso il tuo video</button>
          <button v-if="countdown <= totalTime / 2 && !postRecording" @click="stopRecording" class="button  button--stop">Termina e carica il video</button>
        </div>
        <div class="video" v-else-if="uploading">
          <div class="lds-dual-ring"></div>
          <p class="stay">Rimani su questa pagina sino a che il caricamento del video non è completato.</p>
        </div>
        <div class="video" v-else>
          <video controls class="watch">
            <source :src="videoURL" type="video/mp4">
          </video>
        </div>

        <div v-if="done" class="thanks">
          <p>Il video è stato caricato correttamente. Grazie! Puoi rivederlo qui sopra.</p>
          <p>Vuoi registrare un nuovo video? Se la precedente versione non ti ha soddisfatto, puoi registrare un nuovo video. <a :href="'/?id=' + userID + '&name=' + name + '&surname=' + surname + '&CVweb_Url=' + backURL">Clicca qui per ricominciare.</a></p>

          <a class="button" :href="backURL">Torna a CVweb</a>
        </div>

        <div v-if="error" class="thanks">
          <p>C'è stato un problema con il caricamento del tuo video. Riprova con un altro browser e/o device.</p>
        </div>
      </div>

    </div>
  </main>

</template>

<script setup>
  import { ref, onBeforeUnmount, computed, inject } from 'vue'
  import { useRoute } from 'vue-router';
  import { setDriftlessTimeout, setDriftlessInterval, clearDriftless } from 'driftless'

  const supported = ref(true)

  const checkSupport = () => {
    if (supportRTC()) {
      initVideoCapture().then(() => {
        startStream('video')
        supported.value= true
      })
    } else {
      supported.value = false;
    }
  }

  const supportRTC = () => {
    return 'MediaRecorder' in window
  }

  const timer = ref([])
  const totalTime = ref(60)
  const countdown = ref(60)
  const countdownID = ref('countdown')

  const startCountdown = (elemID, seconds, callback) => {
    if (typeof callback !== 'function') { callback = function () {
      // do nothing.
    } }
    setDriftlessTimeout( () => {
      countdown.value = seconds
      timer.value[elemID] = setDriftlessInterval( () => {
        countdown.value--
        if (countdown.value <= 0) {
          clearDriftless(timer.value[elemID])
          callback()
        }
      }, 1000)
    }, 100)
  }

  const stopCountdown = (elemID) => {
    clearDriftless(timer.value[elemID])
    delete timer.value[elemID]
  }

  const goTo = (videoID) => {
    console.log(videoID)
    document.getElementById(videoID).scrollIntoView();
  }

  const streamSettings = ref({
    audioinput: null,
    audiooutput: null,
    videoinput: null
  })
  const camera = ref(true)
  const mic = ref(true)

  const initVideoCapture = async () => {
    try {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
          for(let i = 0; i <= deviceInfos.length; i++) {
            const device = deviceInfos[i];
            if(typeof device === 'undefined')
              continue;
            switch(device.kind) {
              case 'audioinput':
                if (typeof device.deviceId !== 'undefined') {
                  if (device.deviceId === 'default' || streamSettings.value.audioinput === null) {
                    streamSettings.value.audioinput = device;
                  }
                }
                break;
              case 'audiooutput':
                if (typeof device.deviceId !== 'undefined') {
                  if (device.deviceId === 'default' || streamSettings.value.audiooutput === null) {
                    streamSettings.value.audiooutput = device;
                  }
                }
                break;
              case 'videoinput':
                if (typeof device.deviceId !== 'undefined') {
                  if (device.deviceId === 'default' || device.label.indexOf('front') > 0 || streamSettings.value.videoinput === null) {
                    streamSettings.value.videoinput = device;
                  }
                }
            }
          }
          if (streamSettings.value.videoinput === null || streamSettings.value.audioinput === null) {
            console.log('C\'è qualcosa che non va');
            supported.value = false
            camera.value = streamSettings.value.videoinput === null ? false : true
            mic.value = streamSettings.value.audioinput === null ? false : true
            reject();
          } else {
            resolve();
          }
        });
      });
    } catch(error) {
      supported.value = false;
      console.log('error', error);
    }
  }

  const route = useRoute()

  const backURL = computed (() => route.query.CVweb_Url)
  const name = computed (() => route.query.name)
  const surname = computed (() => route.query.surname)

  const userID = computed (() => {
    const id = route.query.id
    if (isGuid(id)) {
      checkSupport()
    }
    return id
  })

  const isGuid = (value) => {    
    const regex = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/;
    const match = regex.exec(value);
    return match != null;
  }

  

  const recordedBlobs = ref(null)

  const getFileFromRecordedBlobs = () => {
    const fileName = userID.value + '.mp4'
    const file = new File(recordedBlobs.value, fileName, { type: 'video/mp4; codecs=mpeg4', lastModified: Date.now() })
    console.log('file', file)
    return file
  }

  const denied = ref(false)
  const streamStarted = ref(false)

  const startStream = (videoID) => {
    if (window.stream) {
      window.stream.getTracks().forEach(function (track) {
        track.stop()
      })
    }
    if (streamSettings.value.audioinput != undefined && streamSettings.value.videoinput != undefined) {
      const audioSource = streamSettings.value.audioinput.deviceId
      const videoSource = streamSettings.value.videoinput.deviceId
      const fixedWidth = 864
      const fixedHeight = 1080
      const deviceHeight = (window.innerHeight % 2 === 0) ? window.innerHeight : window.innerHeight - 1
      const deviceWidth = (window.innerWidth % 2 === 0) ? window.innerWidth : window.innerWidth - 1
      const idealWidth = (fixedWidth <= deviceWidth && fixedHeight <= deviceHeight) ? fixedWidth : deviceHeight / fixedHeight * fixedWidth
      const idealHeight = (fixedWidth <= deviceWidth && fixedHeight <= deviceHeight) ? fixedHeight : deviceWidth / fixedWidth * fixedHeight

      const constraints = {
        audio: {
          deviceId: audioSource ? {exact: audioSource} : undefined
        },
        video: {
          deviceId: videoSource ? {exact: videoSource} : undefined, 
          frameRate: 25,
          facingMode: 'user', 
          width: { 
            ideal: idealWidth, 
            max: deviceWidth
          }, 
          height: { 
            ideal: idealHeight,
            max: deviceHeight
          }
        }
      }
      
      navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
        window.stream = stream // make stream available to console
        const videoElement = document.getElementById(videoID)
        videoElement.srcObject = stream
        streamStarted.value = true
      }).catch( () => {
        denied.value = true;
      })
    } else {
      supported.value = false;
    }
  }

  const stopStream = (videoID) => {
    if (typeof videoID === 'undefined') { videoID = 'video' }
    if (window.stream != null) {
      window.stream.getTracks().forEach(function (track) {
        track.stop()
      })
    }
    window.stream = null // make stream available to console
    // let videoElement = document.getElementById(videoID)
    // videoElement.srcObject = null
    // initVideoCapture()
    streamStarted.value = false
  }

  const finalStopStream = () => {
    if (window.stream != null) {
      window.stream.getTracks().forEach(function (track) {
        track.stop()
      })
    }
    window.stream = null // make stream available to console
  }

  const recording = ref(false)
  const recordingDelayed = ref(false)
  const postRecording = ref(false)
  const mediaRecorder = ref(null)

  const startRecording = () => {
    goTo('video')
    window.addEventListener('beforeunload', nonChiudere)
    recording.value = true
    setTimeout( () => {
      recordingDelayed.value = true
    }, 400) 
    recordedBlobs.value = []
    let options = {mimeType: 'video/webm;codecs=vp9,opus', videoBitsPerSecond: 256 * 8 * 256}
    if (!MediaRecorder.isTypeSupported(options.mimeType)) {
      console.log(options.mimeType + ' is not Supported')
      options = {mimeType: 'video/webm;codecs=vp8,opus', videoBitsPerSecond: 256 * 8 * 256}
      if (!MediaRecorder.isTypeSupported(options.mimeType)) {
        console.log(options.mimeType + ' is not Supported')
        options = {mimeType: 'video/webm', videoBitsPerSecond: 256 * 8 * 256}
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
          console.log(options.mimeType + ' is not Supported')
          options = {mimeType: '', videoBitsPerSecond: 256 * 8 * 256}
        }
      }
    }
    try {
      mediaRecorder.value = new MediaRecorder(window.stream, options)
    } catch (e) {
      console.error('Exception while creating MediaRecorder: ' + e)
      return
    }
    console.log('Created MediaRecorder', mediaRecorder, 'with options', options)
    console.log('videoBitsPerSecond', mediaRecorder.value.videoBitsPerSecond)
    mediaRecorder.value.onstop = handleStop
    mediaRecorder.value.ondataavailable = handleDataAvailable
    mediaRecorder.value.start(10) // collect 10ms of data
    console.log('MediaRecorder started', mediaRecorder)
    startCountdown(countdownID, totalTime.value, () => {
      stopRecording()
    })
  }

  const videoFile = ref('')
  const videoURL = ref('')
  const uploading = ref(false)

  const stopRecording = () => {
    stopCountdown(countdownID)
    recording.value = false
    recordingDelayed.value = false
    postRecording.value = true
    uploading.value = true
    if (mediaRecorder.value && mediaRecorder.value.state !== 'inactive') {
      mediaRecorder.value.stop()
    }
    console.log('Recorded Blobs: ', recordedBlobs)
    setTimeout( () => {
      videoFile.value = getFileFromRecordedBlobs()
      videoURL.value = URL.createObjectURL(videoFile.value)
      videoUploadAsync()
    }, 1000)
  }
  
  const handleStop = (event) => {
    console.log('Recorder stopped: ', event)
  }

  const handleDataAvailable = (event) => {
    if (event.data && event.data.size > 0) {
      recordedBlobs.value.push(event.data)
    }
  }

  const axios = inject('axios')
  const done = ref(false)
  const error = ref(false)

  const videoUploadAsync = async () => {
    const params = new FormData()
    params.append('file', videoFile.value)
    await axios.post(process.env.VUE_APP_STORAGE + '/video-upload-cesop', params).then((r) => {
      console.log('upload-response', r)
      stopStream('video')
      console.log('upload-finish')
      window.removeEventListener('beforeunload', nonChiudere)
      uploading.value = false
      done.value = true
    }).catch((err) => {
      stopStream('video')
      console.warn('upload-error', err.message)
      window.removeEventListener('beforeunload', nonChiudere)
      uploading.value = false
      error.value = true
    })
  }

  const nonChiudere = (event) => {
    event.preventDefault()
    event.returnValue = ''
  }

  onBeforeUnmount(() => {
    finalStopStream()
    if (mediaRecorder.value && mediaRecorder.value.state !== 'inactive') {
      mediaRecorder.value.stop()
    }
    stopStream();
  })

</script>

<style lang="scss" scoped> 

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 500px;
    margin: 0 auto;
    padding: 0 10px;
    text-align: center;
  }

  .button {
    color: #fff;
    background-color: var(--stress-color);
    border: 0;
    padding: 10px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
  }

  .video {
    position: relative;
    background-color: lightgrey;
    margin: 30px auto;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

      @media (min-width: 470px) {
        width: 470px;
        max-width: 100%;
        aspect-ratio: 470 / 586;
        height: auto;   
      }
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scaleX(-1);
    }

    .watch {
      transform: none;
    }
    
    .countdown {
      position: absolute;
      top: 10px;
      left: 10px; 
      background-color: var(--stress-color);
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      border: 2px solid #fff;
      margin: 0;
      color: #fff;
    }

    .button {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }

    .recording {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: var(--stress-color);
      animation: 2s pulse infinite
    }

    .button--stop {
      right: 10px;
      left: auto;
      transform: none;
    }
  }

  ul {  
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    height: 100%;
    width: 100%;
    flex-direction: column;

    li {
      padding: 0;
      flex: 1;
      list-style: none;;
      border-bottom: 1px solid rgba(255,255,255,.5);

      &:last-child {
        border-bottom: 0;
      }
    }

    button {
      background-color: transparent;
      border: none;
      color: #fff;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
    }

  }

  .splash,
  .not-supported {
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      margin: 20px auto;
      color: var(--stress-color);
    }

    p {
      margin: auto;
      padding: 10px 20px;
    }

    button {
      height: 50px;
      width: 150px;
      border: 2px solid #fff;
      text-transform: uppercase;
      margin: 20px auto;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
      background-color: var(--stress-color);
    }
  }

  .stay {
    padding: 0 20px;
  }

  .thanks {
    margin: 0 20px 30px;
  }

   @keyframes pulse {
      0% {
          transform: scale(1);
      }

      50% {
          transform: scale(1.5);
      }

      100% {
          transform: scale(1.0);
      }
  }

  .lds-dual-ring {
    display: inline-block;
    width: 80px;
    height: 80px;

    &.alone {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

</style>
